/* BG-203: fills the "N in stock" line on home category tiles. The number is `collection.products_count` of
   templates/collection.count.liquid with the availability filter applied, i.e. the collection page's own "In stock (N)".
   A tile with data-tpl (hero small tiles) instead swaps {in_stock} in its .ecard__sub and sets data-filled; zero leaves it hidden.
   shortcut: fetches once per tile per tab session (sessionStorage, 10 min); upgrade to a server-written metafield if load matters. */
(function () {
  function fill(root) {
    root.querySelectorAll('[data-in-stock-url]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '');
      var tpl = el.hasAttribute('data-tpl'), out = tpl ? el.querySelector('.ecard__sub') : el, base = out ? out.textContent : '';
      if (!out) return;
      var url = el.getAttribute('data-in-stock-url'), root = el.closest('[data-country]'), key = 'bgb-cc:' + (root ? root.getAttribute('data-country') : '') + ':' + url, now = Date.now();
      function show(n) {
        var s = Number(n).toLocaleString('en');
        if (!tpl) { el.textContent = s + ' ' + el.getAttribute('data-suffix'); return; }
        if (+n > 0) { out.textContent = base.replace('{in_stock}', s); el.setAttribute('data-filled', ''); }
      }
      try { var c = JSON.parse(sessionStorage.getItem(key)); if (c && Number.isInteger(c.n) && c.n >= 0 && c.n <= 9999999 && isFinite(c.t) && now - c.t >= 0 && now - c.t < 6e5) return show(c.n); } catch (e) {}
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
        var m = /<span id="c">\s*([^<]*?)\s*<\/span>/.exec(t);
        t = m ? m[1] : '';
        if (!/^\d{1,7}$/.test(t)) return;
        show(t);
        try { sessionStorage.setItem(key, JSON.stringify({ n: +t, t: now })); } catch (e) {}
      }).catch(function () {});
    });
  }
  fill(document);
  document.addEventListener('shopify:section:load', function (e) { fill(e.target); });
})();
